import Feature from 'helpers/feature';
import ScoreBasedRecaptcha from 'recaptcha-web-client/ScoreBasedRecaptcha';
import RecaptchaTracking from 'recaptcha/RecaptchaTracking';
export default class Recaptcha {
    /**
     * Fetch and append recaptcha token to the data object
     *
     * @param data
     */
    static async appendRecaptchaToken(data) {
        // check if recaptcha is enabled in cms if so get the recaptcha token 
        // and append it to data.recaptchaToken
        if (data && Feature.isActive('recaptcha')) {
            const recaptchaConfig = {
                siteKey: CBS?.Registry?.Recaptcha?.siteKey ?? 'recaptchaPublicKey-not-found',
                action: data?.recaptchaAction,
                trackingService: new RecaptchaTracking(),
            };
            const recaptchaClient = new ScoreBasedRecaptcha(recaptchaConfig);
            data.recaptchaToken = await recaptchaClient.getToken();

            // delete recaptchaAction from data
            delete data.recaptchaAction;

            const urlParams = new URLSearchParams(window.location.search);
            const debug = urlParams.get('RECAPTCHA_DEBUG');

            if (debug === 'true') {
                data.recaptchaDebug = true;
            }
        }
    }

    /**
     * Track recaptcha trackRecaptchaFailure or trackCaptchaVerified from api response
     *
     * @param response
     */
    static trackRecaptchaTokenValidationResult(response) {
        const tokenValidated = response?.data?.recaptchaTokenValidated ?? response?.recaptchaTokenValidated;
        if (tokenValidated) {
            new RecaptchaTracking().verified();
        } else if (tokenValidated === false) {
            new RecaptchaTracking().failure();
        }
    }
}